import React from 'react';
import PropTypes from 'prop-types';
import { Header, Container } from 'semantic-ui-react';

export default class About extends React.Component {
  renderContainer(child) {
    const { withContainer, centerContent } = this.props;

    return withContainer ? (
      <Container textAlign={centerContent ? 'center' : 'left'}>{child}</Container>
    ) : (
      <div style={centerContent ? { textAlign: 'center' } : {}}>{child}</div>
    );
  }

  render() {
    const { header, content, headerAs } = this.props;

    return this.renderContainer(
      <React.Fragment>
        {header && <Header as={headerAs}>{header}</Header>}
        <p>{content}</p>
      </React.Fragment>,
    );
  }
}

About.propTypes = {
  content: PropTypes.string.isRequired,
  header: PropTypes.string,
  centerContent: PropTypes.bool,
  headerAs: PropTypes.oneOf(['h1', 'h2']),
  withContainer: PropTypes.bool,
};

About.defaultProps = {
  centerContent: false,
  headerAs: 'h1',
  header: '',
  withContainer: false,
};

About.propOptions = {
  header: ['About Us', 'Our Story'],
};

About.dataPropsMap = {
  header: ['business', 'about', 'index', 'title'],
  content: ['business', 'about', 'index', 'content'],
};
